export const outletOverview = {
  nearby: 'Nearby',
  currently_closed: 'Currently Closed',
  more_info: 'More Info',
  back_to: 'Back to {{marketplace}}',
  min_order: 'Min Order {{val}}',
  no_min_order: 'No Min Order',
  no_method_selected: 'No order method selected',
  logo_label: '{{restaurant}} logo',
  no_fulfilment_chosen: 'No fulfilment chosen',
  tomorrow: 'Tomorrow',
  today: 'Today',
  collection: 'Collection',
  delivery: 'Delivery',
  table: 'Table Service',
  back_to_outlets: 'Back to {{urlPath}} near {{ searchLocation }}',
  all: 'All',
  back_to_deliveryzone: 'Back to {{deliveryZoneName}}',
  back_to_outlet_page: 'Back to {{outletName}}',
  back_to_search_results: 'Back to Search Results',
  arriving_by: 'Arriving by',
  ready_by: 'Ready by',
  enter_location: 'Enter Location',
  deals_and_offers: 'Deals & Offers',
  outlet_preview_description: 'Select which outlet you wish to preview.',
  outlet_preview_current: 'Currently viewing: ',
  reviews_sheet_title: 'Customer reviews',
  reviews_sheet_summary: '{{rating}} average rating · {{countText}}',
  reviews_sheet_summary_no_rating: '{{countText}}',
  reviews_sheet_empty_state: 'Reviews will appear here once available.',
  reviews_sheet_loading: 'Loading reviews...',
  reviews_sheet_error: 'We could not load reviews right now.',
  reviews_sheet_not_rated: 'Not rated',
  reviews_sheet_review_count: '{{count}} review',
  reviews_sheet_review_count_plural: '{{count}} reviews',
  reviews_sheet_open_label:
    'View customer reviews ({{rating}} · {{countText}})',
  reviews_sheet_reply_label: 'Business reply',
  reviews_sheet_reply_label_with_time: 'Business reply · {{time}}',
  reviews_sheet_load_more: 'Load more reviews',
  quality_takeaway: 'Food Quality',
  quality_retail: 'Product Quality',
  service: 'Service',
  delivery_time: 'Delivery Time',
}
